import { h3 } from "app/common/components/Containers"
import { RouteMgr } from "app/common/routes"
import { optionalRender } from "app/common/ui/optionalRender"
import { variantsToSrcSet } from "app/common/utilities/html"
import { BrandListVM, ImageVM } from "app/models"
import { TagList } from "app/tags/components/TagList"
import { Link } from "blitz"
import { array } from "fp-ts"
import { pipe } from "fp-ts/function"
import { FC, ReactElement } from "react"
import { tw } from "twind"

interface LogoProps {
  logo: ImageVM
}

const Logo: FC<LogoProps> = ({ logo }) => (
  <img
    alt={logo.alternateText}
    className={tw(`w(24 sm:32)`)}
    height={logo.height}
    sizes={"200px"}
    src={logo.url}
    srcSet={variantsToSrcSet(logo.variants)}
    width={logo.width}
  />
)

interface BrandListProps {
  brands: ReadonlyArray<BrandListVM>
}

export const BrandList = ({ brands }: BrandListProps): ReactElement => {
  return (
    <div className={tw(`flex(& col)`)}>
      {pipe(
        brands,
        array.map((brand) => (
          <article className={tw(`py-4`, `flex(& col) gap-1 items-start`)} key={brand.slug}>
            <div className={tw(`flex(&) gap-2 items-start`)}>
              <div>
                <h2 className={tw(h3, `mb-0`, `text-blue-900`)}>
                  <Link href={RouteMgr.BrandPage({ slug: brand.slug })}>
                    <a className={tw(`flex gap-6 items-start`, `blogLink`)}>{brand.name}</a>
                  </Link>
                </h2>
                <p>{brand.summary}</p>
              </div>
              {pipe(
                brand.logo,
                optionalRender((logo) => <Logo key={logo.url} logo={logo} />)
              )}
            </div>
            <TagList tags={brand.tags} />
          </article>
        ))
      )}
    </div>
  )
}
